import { SELECIONAR_ROTA } from '../types'

export default function selecionarRota (rota) {
  return {
    type: SELECIONAR_ROTA,
    payload: rota
  }
}
